//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DeliveryObligationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDeliveryObligationQueryParameters = {
  lieferant?: string | null | undefined ;
  deliveryDateFrom?: Date | null | undefined ;
  deliveryDateTo?: Date | null | undefined ;
  project?: string | null | undefined ;
  article?: string | null | undefined ;
  isOnlyCriticalProcesses?: boolean | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(lieferant?: string | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, project?: string | null | undefined, article?: string | null | undefined, isOnlyCriticalProcesses?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/delivery-obligation?";
if (lieferant !== undefined && lieferant !== null)
    url_ += "Lieferant=" + encodeURIComponent("" + lieferant) + "&";
if (deliveryDateFrom !== undefined && deliveryDateFrom !== null)
    url_ += "DeliveryDateFrom=" + encodeURIComponent(deliveryDateFrom ? "" + Types.formatDate(deliveryDateFrom) : "") + "&";
if (deliveryDateTo !== undefined && deliveryDateTo !== null)
    url_ += "DeliveryDateTo=" + encodeURIComponent(deliveryDateTo ? "" + Types.formatDate(deliveryDateTo) : "") + "&";
if (project !== undefined && project !== null)
    url_ += "Project=" + encodeURIComponent("" + project) + "&";
if (article !== undefined && article !== null)
    url_ += "Article=" + encodeURIComponent("" + article) + "&";
if (isOnlyCriticalProcesses !== undefined && isOnlyCriticalProcesses !== null)
    url_ += "IsOnlyCriticalProcesses=" + encodeURIComponent("" + isOnlyCriticalProcesses) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.AbasExecuteResponse, unknown, Types.AbasExecuteResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AbasExecuteResponse, unknown, Types.AbasExecuteResponse>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetDeliveryObligationQueryParameters): QueryKey;
export function getQueryKey(lieferant?: string | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, project?: string | null | undefined, article?: string | null | undefined, isOnlyCriticalProcesses?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { lieferant, deliveryDateFrom, deliveryDateTo, project, article, isOnlyCriticalProcesses, offset, limit, sortBy, sortOrder,  } = params[0] as GetDeliveryObligationQueryParameters;

    return trimArrayEnd([
        'DeliveryObligationClient',
        'get',
        lieferant as any,
        deliveryDateFrom as any,
        deliveryDateTo as any,
        project as any,
        article as any,
        isOnlyCriticalProcesses as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'DeliveryObligationClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as Date | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as number | null | undefined,       context.queryKey[10] as string | null | undefined,       context.queryKey[11] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.AbasExecuteResponse, TError = unknown>(dto: GetDeliveryObligationQueryParameters, options?: Omit<UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param lieferant (optional) kkuli
 * @param deliveryDateFrom (optional) belegvon (Liefertermin von)
 * @param deliveryDateTo (optional) belegbis (Liefertermin bis)
 * @param project (optional) projekt
 * @param article (optional) artikel
 * @param isOnlyCriticalProcesses (optional) bkrit (Nur kritische Vorgänge)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.AbasExecuteResponse, TError = unknown>(lieferant?: string | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, project?: string | null | undefined, article?: string | null | undefined, isOnlyCriticalProcesses?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.AbasExecuteResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let lieferant: any = undefined;
  let deliveryDateFrom: any = undefined;
  let deliveryDateTo: any = undefined;
  let project: any = undefined;
  let article: any = undefined;
  let isOnlyCriticalProcesses: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ lieferant, deliveryDateFrom, deliveryDateTo, project, article, isOnlyCriticalProcesses, offset, limit, sortBy, sortOrder,  } = params[0] as GetDeliveryObligationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [lieferant, deliveryDateFrom, deliveryDateTo, project, article, isOnlyCriticalProcesses, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AbasExecuteResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(lieferant, deliveryDateFrom, deliveryDateTo, project, article, isOnlyCriticalProcesses, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param lieferant (optional) kkuli
 * @param deliveryDateFrom (optional) belegvon (Liefertermin von)
 * @param deliveryDateTo (optional) belegbis (Liefertermin bis)
 * @param project (optional) projekt
 * @param article (optional) artikel
 * @param isOnlyCriticalProcesses (optional) bkrit (Nur kritische Vorgänge)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.AbasExecuteResponse | undefined) => Types.AbasExecuteResponse, lieferant?: string | null | undefined, deliveryDateFrom?: Date | null | undefined, deliveryDateTo?: Date | null | undefined, project?: string | null | undefined, article?: string | null | undefined, isOnlyCriticalProcesses?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(lieferant, deliveryDateFrom, deliveryDateTo, project, article, isOnlyCriticalProcesses, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param lieferant (optional) kkuli
 * @param deliveryDateFrom (optional) belegvon (Liefertermin von)
 * @param deliveryDateTo (optional) belegbis (Liefertermin bis)
 * @param project (optional) projekt
 * @param article (optional) artikel
 * @param isOnlyCriticalProcesses (optional) bkrit (Nur kritische Vorgänge)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AbasExecuteResponse | undefined) => Types.AbasExecuteResponse) {
  queryClient.setQueryData(queryKey, updater);
}